export const navigationLinks = [
  { label: 'Forside', href: '/' },
  { label: 'Kontakt', href: '/kontakt' }
];

export const contactInfo = {
  phone: '21 29 83 87',
  email: 'm@ravns.com',
  address: 'Færøvej 107, 9800 Hjørring',
  cvr: '26913292',
  owner: 'Morten Ravn',
  hours: [
    { days: 'Hverdage', time: '09:00 - 17:00' },
    { days: 'Weekend & Helligdage', time: 'Lukket' }
  ]
};

export const calculatorConfig = {
  houseTypes: [
    { id: 'parcelhus', label: 'Parcelhus (1-plan)', basePrice: 149, multiplier: 1.0 },
    { id: 'villa', label: 'Villa / 2-plans hus', basePrice: 199, multiplier: 1.3 },
    { id: 'lejlighed', label: 'Lejlighed', basePrice: 99, multiplier: 0.8 },
    { id: 'raekkehus', label: 'Rækkehus', basePrice: 129, multiplier: 0.95 }
  ],
  windowCounts: [
    { id: 'small', label: 'Få vinduer (1 - 10 stk.)', multiplier: 1.0 },
    { id: 'medium', label: 'Mellem (11 - 20 stk.)', multiplier: 1.4 },
    { id: 'large', label: 'Mange (21 - 30 stk.)', multiplier: 1.8 },
    { id: 'xlarge', label: 'Rigtig mange (Over 30 stk.)', multiplier: 2.3 }
  ],
  extras: [
    { id: 'indvendig', label: 'Indvendig pudsning også', price: 99 },
    { id: 'karmvask_ekstra', label: 'Ekstra grundig karmrens (første gang)', price: 49 }
  ]
};
